import Button from './button';
import ButtonGroup from './button-group';

Button.Group = ButtonGroup;
export {ButtonGroup};
export default Button;
